import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';

function extractErrorMessage(error: HttpErrorResponse): string {
  const errorBody = error.error;
  if (!errorBody || typeof errorBody !== 'object') return '';


  if (typeof errorBody.message === 'string' && errorBody.message.trim()) {
    return errorBody.message.trim();
  }


  if (errorBody.issue?.length > 0) {
    const messages = errorBody.issue
      .filter((issue: any) => issue.severity === 'error' || issue.severity === 'warning')
      .map((issue: any) => issue.details?.text)
      .filter((text: string) => !!text);
    if (messages.length > 0) return messages.join('. ');
  }

  return '';
}

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de joindre le serveur. Vérifiez votre connexion internet.',
          life: 5000
        });
      } else if (error.status === 400 || error.status === 409) {
        const detail = extractErrorMessage(error);
        messageService.add({
          severity: 'warn',
          summary: 'Attention',
          detail: detail,
          life: 8000
        });
      }
      console.error(`[HTTP ${error.status}]`, error.error);
      return throwError(() => error);
    })
  );
};
